module.exports = __webpack_public_path__ + "static/img/dr-dalia.db73219b.jpg";